var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (steps) {pug_html = pug_html + "\u003Cdiv class=\"steps-wizard\"\u003E";
// iterate steps
;(function(){
  var $$obj = steps;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var step = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv class=\"step-container\"\u003E\u003Cdiv" + (" class=\"step-header\""+pug.attr("data-step-name", step.name, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv" + (" class=\"step-body\""+pug.attr("data-step-name", step.name, true, true)) + "\u003E\u003Cdiv class=\"step-content\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv" + (" class=\"step-footer\""+pug.attr("data-step-name", step.name, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var step = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv class=\"step-container\"\u003E\u003Cdiv" + (" class=\"step-header\""+pug.attr("data-step-name", step.name, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv" + (" class=\"step-body\""+pug.attr("data-step-name", step.name, true, true)) + "\u003E\u003Cdiv class=\"step-content\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv" + (" class=\"step-footer\""+pug.attr("data-step-name", step.name, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";}.call(this,"steps" in locals_for_with?locals_for_with.steps:typeof steps!=="undefined"?steps:undefined));;return pug_html;};
module.exports = template;